import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8afc7942"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ant-row",
  style: {"min-height":"calc(17vh - 1px)","border":"1px solid #000066","border-radius":"6px","padding":"8px","align-items":"center"}
}
const _hoisted_2 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-12",
  style: {"height":"98%","padding":"8px","font-size":"28px","display":"flex","flex-direction":"column","justify-content":"center","background-color":"rgb(200, 222, 255)","border-radius":"0 6px 6px 0"}
}
const _hoisted_3 = {
  style: {"font-weight":"bold","color":"#000080","text-align":"center"},
  tabindex: "-1"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-12",
  style: {"height":"98%","font-size":"28px","padding":"8px","display":"flex","flex-direction":"column","justify-content":"center","background-color":"#00bfff","border-radius":"0 6px 6px 0"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"font-weight":"bold","color":"white","text-align":"center"},
  tabindex: "-1"
}, " VALOR TOTAL ", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  class: "ant-row",
  style: {"border":"1px solid #000066","border-radius":"6px","padding":"8px","min-height":"calc(63vh - 1px)"}
}
const _hoisted_9 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-12",
  style: {"padding":"8px","align-items":"center"}
}
const _hoisted_10 = {
  class: "ant-row",
  style: {"height":"110px"}
}
const _hoisted_11 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-20",
  style: {"margin-left":"10px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"larger"} }, "Tipo de Documento: ", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  class: "ant-row",
  style: {"height":"110px"}
}
const _hoisted_15 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-10",
  style: {"padding-left":"10px"}
}
const _hoisted_16 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-10",
  style: {"padding-left":"10px","margin-left":"10px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"larger"} }, "Valor: ", -1))
const _hoisted_18 = {
  class: "ant-row",
  style: {"height":"110px"}
}
const _hoisted_19 = {
  class: "ant-col ant-col-xs-6 ant-col-xl-6",
  style: {"padding-left":"10px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, "Cancelar", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, [
  /*#__PURE__*/_createElementVNode("u", null, "S"),
  /*#__PURE__*/_createTextVNode("alvar")
], -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "ant-col ant-col-xs-12 ant-col-xl-12"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"20px"} }, [
  /*#__PURE__*/_createElementVNode("u", null, "A"),
  /*#__PURE__*/_createTextVNode("dicionar Parcela")
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-12",
  style: {"padding":"8px","align-items":"center"}
}
const _hoisted_29 = { class: "ss-scroll-container" }
const _hoisted_30 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-12",
  style: {"font-size":"large"}
}
const _hoisted_31 = {
  class: "ant-col ant-col-xs-4 ant-col-xl-4",
  style: {"font-size":"large"}
}
const _hoisted_32 = {
  class: "ant-col ant-col-xs-6 ant-col-xl-6",
  style: {"font-size":"large"}
}
const _hoisted_33 = {
  class: "ant-col ant-col-xs-2 ant-col-xl-2",
  style: {"text-align":"center"}
}
const _hoisted_34 = { class: "acoes-item" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-venda-dados-principais" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-12" }, "Tipo Documento"),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-4" }, "Parcela"),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-6" }, "Valor Parcelado"),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xs-2" }, "Ações")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.state.descricaoValor), 1),
        _createElementVNode("input", {
          type: "text",
          tabindex: "-1",
          class: "ant-input hidden ss-movimento-input-totalizador",
          style: {"font-size":"40px","text-align":"center","color":"#000080"},
          value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.valorRestante, 2, true),
          readonly: ""
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("input", {
          type: "text",
          tabindex: "-1",
          class: "ant-input hidden ss-movimento-input-totalizador",
          style: {"font-size":"40px","text-align":"center","color":"white"},
          value: _ctx.UtilitarioMascara.mascararValor(_ctx.props.venda.notaFiscal.totalNotaFiscal, 2, true),
          readonly: ""
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            (_openBlock(), _createBlock(_component_selecionar_tipo_documento_financeiro, {
              ref: "refTipoDocumento",
              key: _ctx.state.tiposDocumentosDisponiveis.length,
              tiposDocumentosEspecificos: _ctx.state.tiposDocumentosDisponiveis,
              empresas: [_ctx.props.venda.notaFiscal.codigoEmpresa],
              onKeydown: _ctx.handleNavegacaoTipoDocumento,
              codigoSelecionado: _ctx.state.detalhePagamento.codigoTipoDocumentoFinanceiro,
              "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.detalhePagamento.codigoTipoDocumentoFinanceiro) = $event)),
              descricaoSelecionado: _ctx.state.detalhePagamento.descricaoTipoDocumentoFinanceiro,
              "onUpdate:descricaoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.detalhePagamento.descricaoTipoDocumentoFinanceiro) = $event)),
              meioPagamentoTipoDocumentoFinanceiro: _ctx.state.tipoDocumentoSelecionado.meioPagamentoTipoDocumentoFinanceiro,
              "onUpdate:meioPagamentoTipoDocumentoFinanceiro": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.tipoDocumentoSelecionado.meioPagamentoTipoDocumentoFinanceiro) = $event)),
              onChange: _ctx.alterarTipoDocumento,
              frenteCaixa: true
            }, null, 8, ["tiposDocumentosEspecificos", "empresas", "onKeydown", "codigoSelecionado", "descricaoSelecionado", "meioPagamentoTipoDocumentoFinanceiro", "onChange"]))
          ])
        ]),
        (_ctx.state.tipoDocumentoSelecionado.meioPagamentoTipoDocumentoFinanceiro >= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_select, {
                    bordered: false,
                    class: "ss-venda-dados-principais ss-select-maior",
                    value: _ctx.state.qtdParcelasSelecionada,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.qtdParcelasSelecionada) = $event)),
                    placeholder: 'Selecione',
                    optionFilterProp: "label",
                    allowClear: true,
                    options: _ctx.state.parcelasDisponiveis
                  }, null, 8, ["value", "options"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_campo_numerico, {
                    ref: "valorRef",
                    valor: _ctx.state.valorParcelado,
                    "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.valorParcelado) = $event)),
                    monetario: true,
                    classCss: 'ss-frente-caixa',
                    onValorDigitado: _ctx.calcularValorRestante,
                    onEnterPressionado: _ctx.handleNavegacaoCampoValor
                  }, null, 8, ["valor", "onValorDigitado", "onEnterPressionado"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-lg ant-btn-secondary",
                    style: {"color":"#000080","background-color":"aliceblue","height":"50px"},
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
                  }, _hoisted_21)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-lg ant-btn-secondary",
                    style: {"color":"#000080","background-color":"aliceblue","height":"50px"},
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
                  }, _hoisted_24)
                ]),
                (_ctx.state.valorRestante > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-lg ant-btn-secondary",
                        style: {"color":"#000080","background-color":"aliceblue","height":"50px"},
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.adicionarDetalhePamento && _ctx.adicionarDetalhePamento(...args)))
                      }, _hoisted_27)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createElementVNode("div", _hoisted_29, [
          _createVNode(_component_a_list, {
            size: "large",
            "data-source": _ctx.computedVenda.notaFiscal.detalhesPagamento
          }, {
            renderItem: _withCtx(({ item, index }) => [
              (_openBlock(), _createBlock(_component_a_list_item, {
                key: item.numeroTitulo
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(item.descricaoTipoDocumentoFinanceiro), 1),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(item.parcela, 0)), 1),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(item.valorPagamento, 2, true)), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.excluirItem(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_35)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            ]),
            header: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          }, 8, ["data-source"])
        ], 512), [
          [_vShow, _ctx.computedVenda.notaFiscal.detalhesPagamento.length > 0]
        ])
      ])
    ])
  ]))
}